<template>
  <div>
    <el-card>
         <el-page-header style="margin-bottom: 30px;" @back="goBack" />
      <el-form ref="form" :model="form" :rules="rule" label-width="110px" :inline="false" size="normal">
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type" @change="">
            <el-radio :label="1">
              提供服务
            </el-radio>
            <el-radio :label="2">
              需要资源
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-col :span="8">
            <el-input v-model="form.title" />
          </el-col>
        </el-form-item>
        <el-form-item label="合作内容" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="6" placeholder="请输入内容" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="行业" prop="bcId">
          <div class="business-trigger" @click="businessPickerVisible = true">
            <template v-if="form.bcId">
              <span class="business-trigger__text">{{ businessDisplayText }}</span>
            </template>
            <span v-else class="business-trigger__placeholder">请选择行业</span>
            <i class="el-icon-arrow-down business-trigger__icon" />
          </div>
        </el-form-item>
        <el-form-item label="地区" prop="area">
          <div class="business-trigger" @click="areaPickerVisible = true">
            <template v-if="form.area.length">
              <span class="business-trigger__text">{{ areaDisplayText }}</span>
            </template>
            <span v-else class="business-trigger__placeholder">请选择国家或区域</span>
            <i class="el-icon-arrow-down business-trigger__icon" />
          </div>
        </el-form-item>
        <el-form-item label="合作截止时间" prop="endTime">
          <el-radio-group v-model="form.endTimeType" @change="">
            <el-radio :label="0">长期有效</el-radio>
            <el-radio :label="1">   <div class="box">
              <el-date-picker v-model="form.endTime" :disabled="form.endTimeType == 0" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" align="right" />
            </div></el-radio>

          </el-radio-group>

        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.isHide" placeholder="请输入" size="medium">
            <el-option label="上架" :value="0" />
            <el-option label="下架" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="图片">
          <uplist
            :action="action"
            :list="this.form.productPicture"
            @changes="c_img"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="onSubmit">{{
            id ? '修改' : '提交'
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <business-category-picker
      :visible.sync="businessPickerVisible"
      :business-list="businessList"
      :sub-business-fallback="configDictionaries.cooperationSubBusiness || []"
      :bc-id="form.bcId"
      :bc-sub-id="form.bcSubId"
      :bc-sub-name="form.businessSubName"
      @confirm="onBusinessConfirm"
    />

    <country-region-picker
      :visible.sync="areaPickerVisible"
      :value="form.area"
      :max="3"
      @confirm="onAreaConfirm"
    />
  </div>
</template>

<script>
import imgup from '../../components/upImg/index.vue'
import rules from '../../utils/rules'
import uplist from '../../components/uplist/index'
import BusinessCategoryPicker from './components/business-category-picker.vue'
import CountryRegionPicker from './components/country-region-picker.vue'
export default {
  components: {
    imgup,
    uplist,
    BusinessCategoryPicker,
    CountryRegionPicker
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      id: null,
      form: {
        realName: '',
        type: '',
        content: '',
        area: [],
        isHide: '',
        productPicture: [],
        bcId: '',
        bcSubId: ''
      },
      subBusinessList: [],
      businessPickerVisible: false,
      areaPickerVisible: false,
      countryItemMap: {},
      header: {
        Token: sessionStorage.getItem('token')
      },
      rule: {
        name: [rules.req('请输入企业名称')],
        logo: [rules.req('请输入企业logo')],
        website: [rules.req('请输入公司官网')],
        city: [rules.req('请输入实际公司地址')],
        people: [rules.req('请输入公司人事')],
        financing: [rules.req('请输入融资情况')],
        type: [rules.req('请输入类型')],
        bcId: [rules.req('请选择行业')],
        serverArea: [rules.req('请输入服务区域')],
        companyDesc: [rules.req('请输入公司简介')]
      },
      action: {
        action: 'cooperation'
      },
      province: {},
      city: {},
      baseurl: this.$store.state.env.cdnImg,
      yu: '/' + process.env.VUE_APP_STATIC_DIR,
      configDictionaries: {}
    }
  },
  computed: {
    businessList() {
      return this.configDictionaries.cooperationBusiness || []
    },
    businessDisplayText() {
      if (!this.form.bcId) return ''
      const parent = this.businessList.find(
        item => this.getItemKey(item) === String(this.form.bcId)
      )
      let text = parent ? this.getItemLabel(parent) : ''
      if (this.form.bcSubId) {
        const sub = this.subBusinessList.find(
          item => this.getItemKey(item) === String(this.form.bcSubId)
        )
        if (sub) {
          text += ` - ${this.getItemLabel(sub)}`
        }
      }
      return text
    },
    areaDisplayText() {
      if (!this.form.area.length) return ''
      return this.form.area
        .map(id => this.countryItemMap[String(id)] || id)
        .join('、')
    }
  },
  created() {
    this.getp()
    this.getform()
    this.loadCountryOptions()
    this.$http
      .get('/admin/Common/getConfigDictionaries?config=cooperationNew')
      .then(({ data: res }) => {
        this.configDictionaries = res.data
        this.updateSubBusinessList()
      })
  },

  methods: {
    getItemKey(item) {
      return String(item.key != null ? item.key : item.id)
    },
    getItemLabel(item) {
      return item.value || item.name || ''
    },
    getBusinessChildren(parentKey) {
      const parent = this.businessList.find(
        item => this.getItemKey(item) === String(parentKey)
      )
      if (!parent) return []
      return parent.children || parent.list || parent.subList || []
    },
    updateSubBusinessList() {
      if (!this.form.bcId && this.form.bcSubId) {
        this.inferBcIdFromSubBusiness()
      }
      let subList = this.getBusinessChildren(this.form.bcId)
      if (!subList.length && this.form.bcId && this.configDictionaries.cooperationSubBusiness) {
        subList = (this.configDictionaries.cooperationSubBusiness || []).filter(item => {
          const parentKey = String(
            item.parentKey != null
              ? item.parentKey
              : item.businessId != null
                ? item.businessId
                : item.pid
          )
          return parentKey === String(this.form.bcId)
        })
      }
      this.subBusinessList = subList
      const validKeys = subList.map(item => this.getItemKey(item))
      if (this.form.bcSubId && !validKeys.includes(String(this.form.bcSubId))) {
        this.form.bcSubId = ''
      }
    },
    onBusinessConfirm({ bcId, bcSubId }) {
      this.form.bcId = bcId
      this.form.bcSubId = bcSubId
      this.updateSubBusinessList()
      this.$refs.form && this.$refs.form.validateField('bcId')
    },
    onAreaConfirm(selected) {
      this.form.area = selected
      this.$refs.form && this.$refs.form.validateField('area')
    },
    async loadCountryOptions() {
      const { data: res } = await this.$http.get('/api/Common/getCountry')
      if (res.errorCode === 200) {
        const map = {}
        const addItems = list => {
          ;(list || []).forEach(item => {
            map[String(item.id)] = item.name
          })
        }
        addItems(res.data.regions)
        addItems(res.data.countries_hot)
        Object.values(res.data.countries_group || {}).forEach(list => addItems(list))
        this.countryItemMap = map
      }
    },
    inferBcIdFromSubBusiness() {
      const subKey = String(this.form.bcSubId || '')
      for (const parent of this.businessList) {
        const children = this.getBusinessChildren(this.getItemKey(parent))
        if (children.some(child => subKey === this.getItemKey(child))) {
          this.form.bcId = this.getItemKey(parent)
          return
        }
      }
      if (this.configDictionaries.cooperationSubBusiness) {
        const item = (this.configDictionaries.cooperationSubBusiness || []).find(
          sub => subKey === this.getItemKey(sub)
        )
        if (item) {
          const parentKey = String(
            item.parentKey != null
              ? item.parentKey
              : item.businessId != null
                ? item.businessId
                : item.pid
          )
          this.form.bcId = parentKey
        }
      }
    },
    parseBcSubId(data) {
      if (data.businessSubId != null && data.businessSubId !== 0 && data.businessSubId !== '0') {
        return String(data.businessSubId)
      }
      if (data.bcSubId != null && data.bcSubId !== 0 && data.bcSubId !== '0') {
        return String(data.bcSubId)
      }
      const legacy = (data.subBusiness || data.field || '')
        .split(',')
        .filter(Boolean)[0]
      return legacy || ''
    },
    c_img(val) {
      this.form.productPicture = val
    },
    handleAvatarSuccess(res, file) {
      if (res.errorCode == 200) {
        console.log(res)
        this.form.productPicture.push({
          name: file.name,
          url: this.baseurl + this.yu + res.data.url
        })
      } else {
        this.form.productPicture = [...this.form.productPicture]
        
      }
    },
    goBack(){
        this.$router.go(-1)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      // var arr = this.form.productPicture.filter(item => item.url != file.url)
      this.form.productPicture = fileList
    },
    async getp() {
      const res = await this.$store.dispatch('getProvince')
      this.province = res.data
    },
    async getc() {
      this.form.city = ''
      const { data: res } = await this.$store.dispatch(
        'getCity',
        this.form.province
      )
      this.city = res
    },
    op() {
      this.getc()
    },
    async onSubmit() {
      var url = this.form.productPicture.map(item =>
        item.url
      )
      url = url.toString()
      const { business, subBusiness, field, bcId, bcSubId, ...formRest } = this.form
      var reqData = {
        ...formRest,
        area: this.form.area.toString(),
        business: this.form.bcId,
        businessSubId: this.form.bcSubId || 0,
        productPicture: url
      }
      if (this.id) {
        var { data: res } = await this.$http.post('/admin/Cooperation/edit', {
          ...reqData,
          id: this.id
        })
      } else {
        var { data: res } = await this.$http.post('/admin/Cooperation/add',reqData)
      }

      if (res.errorCode == 200) {
        this.$message.success(res.message)
        this.goBack()
      } 
    },
    async getform() {
      // console.log(this.$route.query + 'sadsadsad')
      if (this.$route.query.id) {
        var id = this.$route.query.id
        this.id = id
        this.$http
          .get('/admin/Cooperation/getById?id=' + id)
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              // console.log(res);
              var yyds = res.data.productPicture.split(',').filter(Boolean)
              // console.log(yyds.filter(true));
              var url = []
              yyds.forEach(item => {
                //  if(item){
                url.push({
                  name: '1',
                  url: item
                })
                //  }
              })
              this.form = {
                ...res.data,
                area: res.data.area.split(',').filter(Boolean),
                bcId: String(
                  res.data.bcId ||
                  res.data.business ||
                  ''
                ).split(',').filter(Boolean)[0] || '',
                bcSubId: this.parseBcSubId(res.data),
                productPicture: url
              }
              this.updateSubBusinessList()
              // console.log(this.form)
              this.form.id = id * 1
              //  this.form.initViews =
              //   Math.floor(Math.random() * (200 - 50 + 1)) + 50
            } 
          })
      }
    },
    setImg(val) {
      this.form.logo = val
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  display: inline-block;
  width: 300px;
}

.business-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 360px;
  height: 40px;
  padding: 0 12px;
  color: #303133;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: #c0c4cc;
  }

  &__text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }

  &__placeholder {
    flex: 1;
    color: #c0c4cc;
    font-size: 14px;
  }

  &__icon {
    flex-shrink: 0;
    margin-left: 8px;
    color: #c0c4cc;
    font-size: 14px;
  }
}
</style>
